import React from "react";
import { string } from "prop-types";

const RightArrowButton = ({ color = "#4785ff" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60">
    <defs>
      <filter id="a" width="60" height="60" x="0" y="0" filterUnits="userSpaceOnUse">
        <feOffset dy="3" />
        <feGaussianBlur result="blur" stdDeviation="3" />
        <feFlood floodOpacity=".322" />
        <feComposite in2="blur" operator="in" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g data-name="Group 3578">
      <g filter="url(#a)">
        <circle cx="21" cy="21" r="21" data-name="Ellipse 68" transform="translate(9 6)" fill={color} />
      </g>
      <path
        d="M26.5 19.5l8 8-8 8"
        data-name="Path 51"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="1"
      />
    </g>
  </svg>
);

RightArrowButton.propTypes = {
  color: string
};

export default RightArrowButton;
